import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./GetInTouch.css";

const GetInTouch = ({ id }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorKey, setErrorKey] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrorKey("");
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      setErrorKey("appointment.validation_error");
      return;
    }
    setLoading(true);

    const translatedData = {
      message_title: t("getInTouch.email.message_title", {
        name: formData.name,
      }),
      name_label: t("getInTouch.email.name_label"),
      email_label: t("getInTouch.email.email_label"),
      phone_label: t("getInTouch.email.phone_label"),
      message_label: t("getInTouch.email.message_label"),
      time_label: t("getInTouch.email.time_label"),
      footer_message: t("getInTouch.email.footer_message"),
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_evdnkds",
        "template_t03miu8",
        translatedData,
        "QSLNz_nvCYayVc6Q-"
      )
      .then(
        () => {
          setLoading(false);
          alert(t("getInTouch.form.success"));
          setFormData({ name: "", email: "", phone: "", message: "" });
        },
        (error) => {
          setLoading(false);
          alert(t("getInTouch.form.error"));
          console.error(error);
        }
      );
  };

  return (
    <section className="get-in-touch-section" id={id}>
      <div className="get-in-touch-container">
        <div className="get-in-touch-info">
          <h2 className="get-in-touch-title">{t("getInTouch.title")}</h2>
          <h1 className="get-in-touch-heading">{t("getInTouch.heading")}</h1>
          <p className="get-in-touch-description">
            {t("getInTouch.description")}
          </p>
          <div className="get-in-touch-details">
            <a
              href="https://maps.app.goo.gl/bJStVzyBz6TAqQxQ7?g_st=ic"
              target="_blank"
              rel="noopener noreferrer"
              className="get-in-touch-detail"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FaMapMarkerAlt
                className="detail-icon"
                size={20}
                color="#4a7cd2"
              />
              <div>
                <p className="detail-title">
                  {t("getInTouch.details.location.title")}
                </p>
                <p className="detail-text">
                  {t("getInTouch.details.location.text")}
                </p>
              </div>
            </a>
            <a
              href="tel:00201221257661"
              className="get-in-touch-detail"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FaPhone className="detail-icon" size={20} color="#4a7cd2" />
              <div>
                <p className="detail-title">
                  {t("getInTouch.details.call.title")}
                </p>
                <p className="detail-text">
                  {t("getInTouch.details.call.text")}
                </p>
              </div>
            </a>
            <a
              href="mailto:draliobida@gmail.com"
              className="get-in-touch-detail"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FaEnvelope className="detail-icon" size={20} color="#4a7cd2" />
              <div>
                <p className="detail-title">
                  {t("getInTouch.details.message.title")}
                </p>
                <p className="detail-text">
                  {t("getInTouch.details.message.text")}
                </p>
              </div>
            </a>
          </div>
        </div>
        <div className="get-in-touch-form">
          <h3 className="form-title">{t("getInTouch.form.title")}</h3>
          {errorKey && <p className="form-error">{t(errorKey)}</p>}
          <form onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              placeholder={t("getInTouch.form.placeholders.name")}
              className="form-input"
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder={t("getInTouch.form.placeholders.email")}
              className="form-input"
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder={t("getInTouch.form.placeholders.phone")}
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder={t("getInTouch.form.placeholders.message")}
              className="form-input form-textarea"
              value={formData.message}
              onChange={handleChange}
            />
            <button type="submit" className="form-button" disabled={loading}>
              {loading
                ? t("getInTouch.form.loading")
                : t("getInTouch.form.button")}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
